var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "list-foot" }, [
    _c("span", { staticClass: "feedback", on: { click: _vm.goFeedback } }, [
      _vm._v(_vm._s(_vm.$t("list.feedback")))
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "memory-wrap clearfix" }, [
      _c("div", { staticClass: "memory-progress-bar" }, [
        _c("div", {
          staticClass: "memory-used memory-used-notebook",
          style: {
            width: _vm.usedPercentage + _vm.notebookUsedPercentage + "%"
          }
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "memory-used",
          style: { width: _vm.usedPercentage + "%" }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "memory-text" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("list.used")) +
            " " +
            _vm._s(_vm.memoryUsed) +
            "/" +
            _vm._s(_vm.$t("list.total")) +
            " " +
            _vm._s(_vm.memoryTotal) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "app-version" }, [
        _c("span", [_vm._v(_vm._s(_vm.version))])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "product-memory-tip" }, [
      _c("span", { staticClass: "circel" }),
      _vm._v(" "),
      _c("span", [_vm._v("ET")]),
      _vm._v(" "),
      _c("span", { staticClass: "circel notebook" }),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.$t("index.notebook")))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fe9dc5c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fe9dc5c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListFoot.vue
// module id = null
// module chunks = 